import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { Redirect } from 'react-router-dom';

import InputField from 'components/LoginForm/Input';
import SellingPoints from 'components/SellingPoints';

export default class Email extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: '',
    };
  }

  render() {
    const { redirect, time, date } = this.state;
    const { defaultVal, change, submit, loadingAnim, signUpRoute, forgotPasswordRoute } = this.props;

    return (
      <div className="Email">
        <h3>{i18n.translate('loginScreen.welcome.headerTop')}</h3>
        <h3>{i18n.translate('loginScreen.welcome.headerBottom')}</h3>
        <SellingPoints />

        <div className="Email__input">
          <a href="/sso" className="btn">Login &gt;</a>        
        </div>
          <a href="/sso"><p className="promotion">Sign up and complete our training program to be eligible to receive a $100 Gift Card on your first booking.</p></a>
      </div>
    );
  }
}

Email.propTypes = {
  defaultVal: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  signUpRoute: PropTypes.func.isRequired,
  forgotPasswordRoute: PropTypes.func.isRequired,
};
